import { FlightTypeEnum } from "@repo/ui/types/modifyBooking";
import type { Journeyv2 } from "@repo/ui/types/modifyBooking";
import type { GroupedStations } from "@repo/ui/types/stations";

export function formatTime(isoString: string | undefined | null): string {
  if (!isoString) return "N/A";

  try {
    const date = new Date(isoString);
    if (Number.isNaN(date.getTime())) return "N/A";

    const hours = date.getHours().toString().padStart(2, "0");
    const minutes = date.getMinutes().toString().padStart(2, "0");
    return `${hours}:${minutes}`;
  } catch {
    return "N/A";
  }
}

export const getFlightType = (flight: Journeyv2): FlightTypeEnum => {
  const { segments = [] } = flight;

  if (segments.length > 1) {
    return FlightTypeEnum.CONNECTING;
  }

  if (segments.length === 1) {
    const segment = segments[0];
    const legs = segment?.legs || [];

    if (legs.length > 1) {
      return FlightTypeEnum.STOPOVER;
    }

    if (legs.length === 1) {
      return FlightTypeEnum.DIRECT;
    }
  }

  return FlightTypeEnum.DIRECT;
};

export const getCityNameByCode = (
  code: string,
  destinations: GroupedStations,
): string | undefined => {
  for (const country of Object.values(destinations)) {
    if (!Array.isArray(country)) continue;

    const match = country.find((dest) => dest.code === code);
    if (match) return match.city;
  }

  for (const country of Object.values(destinations)) {
    if (!Array.isArray(country)) continue;

    const match = country.find((dest) => dest.cityCode === code);
    if (match) return match.city;
  }

  return undefined;
};
